
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const TrapTarotPage = lazy(() => import('../pages/trap-tarot/page'));
const HopeRitualPage = lazy(() => import('../pages/hope-ritual/page'));
const RemindersPage = lazy(() => import('../pages/reminders/page'));
const VlogsPage = lazy(() => import('../pages/vlogs/page'));
const ShadowWorkPage = lazy(() => import('../pages/shadow-work/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/product/:productId',
    element: <ProductDetailPage />,
  },
  {
    path: '/trap-tarot',
    element: <TrapTarotPage />,
  },
  {
    path: '/hope-ritual',
    element: <HopeRitualPage />,
  },
  {
    path: '/reminders',
    element: <RemindersPage />,
  },
  {
    path: '/vlogs',
    element: <VlogsPage />,
  },
  {
    path: '/shadow-work',
    element: <ShadowWorkPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
